import React from "react";
import Footer from "../components/Footer";
import "../css/acercade.css"; // Si querés hacerle estilos extra

const AcercaDe = () => {
  return (
    <>
    <div className="container text-center mt-5">
      <h1 className="mb-4">Sistema de Seguimiento</h1>
      <h2 className="mb-4">Comercial Agricola San Pancracio SRL</h2>
      <p className="lead">
        Versión: <strong>1.0</strong>
      </p>

      <p className="mt-3">
        Esta plataforma ha sido diseñada para gestionar y monitorear
        eficientemente las opeaciones comerciales
      </p>

      <p className="mt-3">
      realizadas por San Pancracio SRL, mejorando el control, logístico y la trazabilidad de los operaciones.
      </p>

      <p className="mt-3 text-muted">
        Proyecto desarrollado en ReactJS con Node.js y MongoDB.
      </p>

      <footer className="mt-5 text-muted">
        © {new Date().getFullYear()} San Pancracio SRL. Todos los derechos reservados.
      </footer>
          
    </div>
    <Footer />
    </>
  );
};

export default AcercaDe;
